/** Canonical Whatnot category pairs supplied by the operator on 2026-10-03.
 * Keep spelling and punctuation exactly as provided in docs/data/whatnot-categories.tsv.
 * These pairs populate the main inventory category tree.
 */
export const WHATNOT_CATEGORIES: Readonly<Record<string, readonly string[]>> = {
  "Antiques, Vintage & Ephemera": [
    "Antiques",
    "Ephemera & Postcards",
    "Postage Stamps",
    "Vintage Decor"
  ],
  "Arts & Handmade": [
    "3D Prints",
    "Art & Prints",
    "Artisan Home Goods",
    "Beads, Pens & Keychains",
    "Craft Stamps",
    "Embroidery and Needlework",
    "Fiber Arts & Sewing Supplies",
    "Glass Art",
    "Handmade Clothing & Accessories",
    "Heat Transfers & Wraps",
    "Jewelry Making Supplies",
    "Other Craft Supplies",
    "Resin Art",
    "Scrapbooks",
    "Stickers",
    "Woodworking"
  ],
  "Baby & Kids": [
    "Baby & Kids Clothes",
    "Baby & Kids Shoes",
    "Baby & Kids Supplies"
  ],
  "Bags & Accessories": [
    "Luxury Bags & Accessories",
    "Midrange & Fashion Bags",
    "Other Accessories",
    "Sunglasses & Eyewear"
  ],
  "Beauty": [
    "Bath & Body Essentials",
    "Fragrances",
    "Hair Products",
    "Makeup & Skincare",
    "Men's Grooming",
    "Nails",
    "Other Beauty"
  ],
  "Books": [
    "Graphic Novels",
    "Magazines",
    "New & Used Books",
    "Rare & Vintage Books"
  ],
  "Car Parts": [
    ""
  ],
  "Case Packs & Bundles": [
    ""
  ],
  "Coins & Money": [
    "Coins & Bullion",
    "Paper Money & Currency"
  ],
  "Comics & Manga": [
    "Anime & Manga",
    "Comic Art",
    "Modern Comics",
    "Pop Culture Memorabilia",
    "Vintage Comics"
  ],
  "Disneyana": [
    "Disney Accessories",
    "Disney Clothing",
    "Disney Original & Animation Art",
    "Disney Pins",
    "Loungefly",
    "Other Disneyana"
  ],
  "Electronics": [
    "Cameras & Photography",
    "Everyday Electronics",
    "Headphones and Speakers",
    "Home Appliances",
    "Other Electronics",
    "Tools"
  ],
  "Entertainment Cards": [
    "Disney Cards",
    "Garbage Pail Kids",
    "Marvel Cards",
    "Other Entertainment Cards",
    "Star Wars Cards",
    "TV & Movie Cards"
  ],
  "Estate Sales & Storage Units": [
    "Deal Hunting",
    "Estate Sales",
    "Garage Sales",
    "Other Estate Sales & Storage Units",
    "Storage Unit Finds"
  ],
  "Food & Drink": [
    "Baked Goods",
    "Candy",
    "Chocolate",
    "Coffee & Tea",
    "Condiments & Sauces",
    "Fresh Produce",
    "Other Food & Drink",
    "Perishable Food - Ships UPS",
    "Snacks",
    "Soda & Drinks",
    "Supplements"
  ],
  "Home & Garden": [
    "Candles & Aromatherapy",
    "Hand Tools",
    "Holiday Decor",
    "Home Decor",
    "Hydration",
    "Kitchen & Dining",
    "Other Home & Garden",
    "Plants & Garden"
  ],
  "Jewelry": [
    "Contemporary Costume",
    "Fine & Precious Metals",
    "Handcrafted & Artisan Jewelry",
    "Men's Jewelry",
    "Vintage & Antique Jewelry"
  ],
  "Knives & Hunting": [
    ""
  ],
  "Men's Fashion": [
    "Men's Formalwear",
    "Men's Modern",
    "Men's Vintage Clothing",
    "Other Men's Fashion",
    "Sports Jerseys"
  ],
  "Movies": [
    "Blu-ray",
    "DVDs",
    "Movie Memorabilia",
    "VHS"
  ],
  "Music": [
    "CDs & Cassettes",
    "Instruments & Accessories",
    "Music Memorabilia",
    "Other Music",
    "Vinyl Records"
  ],
  "Outdoor Gear": [
    "Camping and Hiking Gear",
    "Lures",
    "Other Fishing Equipment",
    "Other Outdoors Gear",
    "Reels",
    "Rods",
    "Winter Sports"
  ],
  "Pallets": [
    ""
  ],
  "Pet Supplies": [
    "Horse Tack",
    "Other Pets",
    "Pet Fish",
    "Pet Supplies"
  ],
  "Rocks & Crystals": [
    "Crystals & Gems",
    "Fossils",
    "Mineral Specimens",
    "Other Rocks"
  ],
  "Sneakers & Streetwear": [
    "Sneakers",
    "Streetwear"
  ],
  "Sporting Gear": [
    "Baseball & Softball",
    "Cycling",
    "Disc Golf",
    "Football",
    "Golf Accessories",
    "Golf Apparel",
    "Golf Bags",
    "Golf Balls",
    "Golf Clubs",
    "Golf Shoes",
    "Other Golf Items",
    "Other Sporting Goods",
    "Racquet Sports",
    "Skateboarding",
    "Soccer"
  ],
  "Sports Cards": [
    "AFL Breaks",
    "AFL Mystery",
    "AFL Singles",
    "Baseball Breaks",
    "Baseball Mystery",
    "Baseball Singles",
    "Basketball Breaks",
    "Basketball Mystery",
    "Basketball Singles",
    "F1 Cards",
    "Football Breaks",
    "Football Mystery",
    "Football Singles",
    "Hockey Breaks",
    "Hockey Mystery",
    "Hockey Singles",
    "NASCAR Cards",
    "Other Sports Cards",
    "Rugby Breaks",
    "Rugby Mystery",
    "Rugby Singles",
    "Soccer Breaks",
    "Soccer Mystery",
    "Soccer Singles",
    "Tennis Breaks",
    "Tennis Mystery",
    "Tennis Singles",
    "UFC Breaks",
    "UFC Mystery",
    "UFC Singles",
    "Wrestling Breaks",
    "Wrestling Mystery",
    "Wrestling Singles"
  ],
  "Sports Memorabilia": [
    "Baseball Bats",
    "Baseball Jerseys",
    "Baseball Photos",
    "Baseballs",
    "Basketball Jerseys",
    "Basketball Photos",
    "Basketballs",
    "Football Jerseys",
    "Football Photos",
    "Footballs",
    "Helmets",
    "Other Baseball Memorabilia",
    "Other Basketball Memorabilia",
    "Other Football Memorabilia",
    "Other Soccer Memorabilia",
    "Other Sports Memorabilia",
    "Soccer Balls",
    "Soccer Jerseys",
    "Soccer Photos"
  ],
  "Toys & Hobbies": [
    "Anime Figures",
    "Baby & Kids Toys",
    "Barbie",
    "Beanie Babies & Boos",
    "Bearbrick",
    "Board Games",
    "D&D & Role-playing Games",
    "DC Figures",
    "Diecast Cars",
    "Disney Plush",
    "Fast Food & Cereal Toys",
    "FigPin",
    "Funko Pop!",
    "Funko Soda",
    "G.I. Joe Figures",
    "Hot Toys",
    "Kawaii",
    "LEGO Minifigures",
    "LEGO Sets",
    "Labubu & Blindboxes",
    "Littlest Pet Shop",
    "MOTU Figures",
    "Marbles",
    "Marvel Figures",
    "Models & Kits",
    "Monster High",
    "Other Action Figures",
    "Other Designer Toys",
    "Other Diecast",
    "Other Dolls",
    "Other Funko Products",
    "Other LEGO",
    "Other Plush",
    "Other Tabletop Games",
    "Other Toys",
    "Pokémon Plush",
    "Power Rangers",
    "Puzzles",
    "Radio Control Vehicles & Toys",
    "Simpsons Figures",
    "Slime & Squishy Toys",
    "Slot Cars",
    "Sonny Angel and Smiski",
    "Squishmallows",
    "Star Wars Figures",
    "TMNT Figures",
    "Thrilljoy",
    "Transformers Figures",
    "Vintage Toys",
    "Warhammer 40k & Wargames",
    "Wrestling Figures"
  ],
  "Trading Card Games": [
    "Akora",
    "DC Cards",
    "Digimon Cards",
    "Dragon Ball Cards",
    "Flesh & Blood",
    "Gundam",
    "Kickstarter & Other Cards",
    "Kryptik",
    "Lorcana",
    "Magic: The Gathering",
    "MetaZoo",
    "Naruto Cards",
    "One Piece Cards",
    "Palworld",
    "Pokémon Cards",
    "Riftbound",
    "Sorcery: Contested Realm",
    "TCG Accessories",
    "UniVersus Cards",
    "Union Arena",
    "VeeFriends",
    "Weiß Schwarz",
    "Yu-Gi-Oh! Cards"
  ],
  "Video Games": [
    "Consoles & Accessories",
    "Modern Games",
    "Retro Games",
    "Strategy Guides, Manuals, Replacement Cases"
  ],
  "Watches": [
    ""
  ],
  "Women's Fashion": [
    "Other Women's Fashion",
    "Women's Activewear",
    "Women's Contemporary",
    "Women's Shoes",
    "Women's True Vintage",
    "Y2K"
  ],
  "and Whatnot": [
    "Breweriana",
    "Other"
  ]
};

export function whatnotSubCategories(category: string): readonly string[] {
  return Object.prototype.hasOwnProperty.call(WHATNOT_CATEGORIES, category)
    ? WHATNOT_CATEGORIES[category]! : [];
}

export function isWhatnotCategoryPair(category: string, subCategory: string): boolean {
  return whatnotSubCategories(category).includes(subCategory);
}

/** Exact condition labels; capitalization differences in the source are intentional. */
export const WHATNOT_CONDITIONS_BY_CATEGORY: Readonly<Record<string, readonly string[]>> = {
  "Antiques": [
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Ephemera & Postcards": [
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Postage Stamps": [
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Vintage Decor": [
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Art & Prints": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Beads, Pens & Keychains": [
    "New",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Fiber Arts & Sewing Supplies": [
    "New",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Jewelry Making Supplies": [
    "New",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Other Craft Supplies": [
    "New",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Baby & Kids Clothes": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Baby & Kids Shoes": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Baby & Kids Supplies": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Luxury Bags & Accessories": [
    "New With Tags",
    "New Without Tags",
    "New With Defects",
    "Excellent",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Midrange & Fashion Bags": [
    "New With Tags",
    "New Without Tags",
    "New with Defects",
    "Excellent",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Other Accessories": [
    "New With Tags",
    "New Without Tags",
    "New With Defects",
    "Excellent",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Sunglasses & Eyewear": [
    "New With Tags",
    "New Without Tags",
    "New With Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Very Good",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Poor"
  ],
  "Graphic Novels": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Magazines": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "New & Used Books": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Rare & Vintage Books": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Coins & Bullion": [
    "Poor - Fair",
    "Good - Extremely Fine",
    "Uncirculated - Mint"
  ],
  "Paper Money & Currency": [
    "Gem Uncirculated",
    "Uncirculated",
    "Very Fine",
    "Fine",
    "Good",
    "Poor"
  ],
  "Anime & Manga": [
    "Graded",
    "Gem Mint",
    "Mint",
    "Near Mint",
    "Very Fine",
    "Fine",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Comic Art": [
    "Graded",
    "Gem Mint",
    "Mint",
    "Near Mint",
    "Very Fine",
    "Fine",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Modern Comics": [
    "Graded",
    "Gem Mint",
    "Mint",
    "Near Mint",
    "Very Fine",
    "Fine",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Pop Culture Memorabilia": [
    "Graded",
    "Gem Mint",
    "Mint",
    "Near Mint",
    "Very Fine",
    "Fine",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Vintage Comics": [
    "Graded",
    "Gem Mint",
    "Mint",
    "Near Mint",
    "Very Fine",
    "Fine",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Disney Pins": [
    "New",
    "Used"
  ],
  "Cameras & Photography": [
    "Brand New",
    "Open-box",
    "Refurbished - Excellent",
    "Refurbished - Very Good",
    "Refurbished - Good",
    "Refurbished - Fair",
    "Used and fully functioning",
    "For parts, not fully functioning, or untested"
  ],
  "Everyday Electronics": [
    "Brand New",
    "Open-box",
    "Refurbished - Excellent",
    "Refurbished - Very Good",
    "Refurbished - Good",
    "Refurbished - Fair",
    "Used and fully functioning",
    "For parts, not fully functioning, or untested"
  ],
  "Headphones and Speakers": [
    "Brand New",
    "Open-box",
    "Refurbished - Excellent",
    "Refurbished - Very Good",
    "Refurbished - Good",
    "Refurbished - Fair",
    "Used and fully functioning",
    "For parts, not fully functioning, or untested"
  ],
  "Home Appliances": [
    "Brand New",
    "Open-box",
    "Refurbished - Excellent",
    "Refurbished - Very Good",
    "Refurbished - Good",
    "Refurbished - Fair",
    "Used and fully functioning",
    "For parts, not fully functioning, or untested"
  ],
  "Other Electronics": [
    "Brand New",
    "Open-box",
    "Refurbished - Excellent",
    "Refurbished - Very Good",
    "Refurbished - Good",
    "Refurbished - Fair",
    "Used and fully functioning",
    "For parts, not fully functioning, or untested"
  ],
  "Tools": [
    "Brand New",
    "Open-box",
    "Refurbished - Excellent",
    "Refurbished - Very Good",
    "Refurbished - Good",
    "Refurbished - Fair",
    "Used and fully functioning",
    "For parts, not fully functioning, or untested"
  ],
  "Disney Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Garbage Pail Kids": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Marvel Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Other Entertainment Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Star Wars Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "TV & Movie Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Hand Tools": [
    "New with box",
    "New without box",
    "New with defects",
    "Refurbished",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Home Decor": [
    "New with box",
    "New without box",
    "New with defects",
    "Refurbished",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Kitchen & Dining": [
    "New with box",
    "New without box",
    "New with defects",
    "Refurbished",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Other Home & Garden": [
    "New with box",
    "New without box",
    "New with defects",
    "Refurbished",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Contemporary Costume": [
    "New",
    "New with defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Fine & Precious Metals": [
    "New",
    "New with defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Handcrafted & Artisan Jewelry": [
    "New",
    "New with defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Men's Jewelry": [
    "New",
    "New with defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Vintage & Antique Jewelry": [
    "New",
    "New with defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Men's Formalwear": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Men's Modern": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Men's Vintage Clothing": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Other Men's Fashion": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Sports Jerseys": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Blu-ray": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "DVDs": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "Movie Memorabilia": [
    "Mint",
    "Excellent",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "VHS": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Fair",
    "Poor"
  ],
  "CDs & Cassettes": [
    "Mint (M)",
    "Near mint (NM)",
    "Excellent (EX)",
    "Very Good Plus (VG+)",
    "Very Good (VG), Good Plus (G+)",
    "Good (G)",
    "Poor (P)",
    "Fair (F)"
  ],
  "Instruments & Accessories": [
    "Mint",
    "Excellent",
    "Very Good",
    "Good, Fair",
    "Poor"
  ],
  "Music Memorabilia": [
    "Mint",
    "Excellent",
    "Very Good",
    "Good, Fair",
    "Poor"
  ],
  "Vinyl Records": [
    "Mint (M)",
    "Near Mint (NM or M-)",
    "Excellent (EX)",
    "Very Good Plus (VG+)",
    "Very Good (VG)",
    "Good Plus (G+)",
    "Good (G)",
    "Fair (F)"
  ],
  "Camping and Hiking Gear": [
    "New",
    "pre-owned - Excellent",
    "pre-owned - good",
    "pre-owned - fair",
    "pre-owned - damaged"
  ],
  "Lures": [
    "New",
    "pre-owned - Excellent",
    "pre-owned - good",
    "pre-owned - fair",
    "pre-owned - damaged"
  ],
  "Other Fishing Equipment": [
    "New",
    "pre-owned - Excellent",
    "pre-owned - good",
    "pre-owned - fair",
    "pre-owned - damaged"
  ],
  "Other Outdoors Gear": [
    "New",
    "pre-owned - Excellent",
    "pre-owned - good",
    "pre-owned - fair",
    "pre-owned - damaged"
  ],
  "Reels": [
    "New",
    "pre-owned - Excellent",
    "pre-owned - good",
    "pre-owned - fair",
    "pre-owned - damaged"
  ],
  "Rods": [
    "New",
    "pre-owned - Excellent",
    "pre-owned - good",
    "pre-owned - fair",
    "pre-owned - damaged"
  ],
  "Winter Sports": [
    "New",
    "pre-owned - Excellent",
    "pre-owned - good",
    "pre-owned - fair",
    "pre-owned - damaged"
  ],
  "Sneakers": [
    "New",
    "New With Defects",
    "Used",
    "Not Specified"
  ],
  "Streetwear": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Golf Accessories": [
    "New",
    "Used"
  ],
  "Golf Apparel": [
    "New",
    "Used"
  ],
  "Golf Bags": [
    "New",
    "Used"
  ],
  "Golf Balls": [
    "New",
    "Used"
  ],
  "Golf Clubs": [
    "New",
    "Used"
  ],
  "Golf Shoes": [
    "New",
    "Used"
  ],
  "AFL Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Baseball Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Basketball Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Football Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Hockey Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Other Sports Cards": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Rugby Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Soccer Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Tennis Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "UFC Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Wrestling Singles": [
    "Graded",
    "Raw - Near Mint or Better",
    "Raw - Excellent",
    "Raw - Very Good",
    "Raw - Poor"
  ],
  "Anime Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Beanie Babies & Boos": [
    "New",
    "Used"
  ],
  "DC Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Diecast Cars": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Disney Plush": [
    "New",
    "Used"
  ],
  "Funko Pop!": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Funko Soda": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "G.I. Joe Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Hot Toys": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "LEGO Minifigures": [
    "New in box",
    "New with damaged box",
    "New without box",
    "Used - Like New",
    "Used - Good",
    "Used - Fair",
    "Used - Poor"
  ],
  "LEGO Sets": [
    "New in box",
    "New with damaged box",
    "New without box",
    "Used - Like New",
    "Used - Good",
    "Used - Fair",
    "Used - Poor"
  ],
  "MOTU Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Marvel Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Other Action Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Other Diecast": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Other Funko Products": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Other LEGO": [
    "New in box",
    "New with damaged box",
    "New without box",
    "Used - Like New",
    "Used - Good",
    "Used - Fair",
    "Used - Poor"
  ],
  "Other Plush": [
    "New",
    "Used"
  ],
  "Pokémon Plush": [
    "New",
    "Used"
  ],
  "Power Rangers": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Simpsons Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Squishmallows": [
    "New",
    "Used"
  ],
  "Star Wars Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "TMNT Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Transformers Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Wrestling Figures": [
    "Mint",
    "Near Mint",
    "Good",
    "Fair",
    "Poor"
  ],
  "Akora": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "DC Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Digimon Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Dragon Ball Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Flesh & Blood": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Gundam": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Kickstarter & Other Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Kryptik": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Lorcana": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Magic: The Gathering": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "MetaZoo": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Naruto Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "One Piece Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Palworld": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Pokémon Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Riftbound": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Sorcery: Contested Realm": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "TCG Accessories": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "UniVersus Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Union Arena": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "VeeFriends": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Weiß Schwarz": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Yu-Gi-Oh! Cards": [
    "Graded",
    "New",
    "Mint",
    "Near Mint",
    "Light Played",
    "Moderately Played",
    "Heavily Played",
    "Damaged"
  ],
  "Consoles & Accessories": [
    "Brand New, Factory Sealed",
    "Open Box",
    "Refurbished",
    "Used",
    "For Parts or Not Working"
  ],
  "Modern Games": [
    "Brand New, Factory Sealed",
    "Complete in Box",
    "Missing Manual",
    "Loose",
    "Graded"
  ],
  "Retro Games": [
    "Brand New, Factory Sealed",
    "Complete in Box",
    "Missing Manual",
    "Loose",
    "Graded"
  ],
  "Strategy Guides, Manuals, Replacement Cases": [
    "Brand New",
    "Like New",
    "Very Good",
    "Good",
    "Acceptable"
  ],
  "Other Women's Fashion": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Women's Activewear": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Women's Contemporary": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Women's Shoes": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Women's True Vintage": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ],
  "Y2K": [
    "New With Tags",
    "New without Tags",
    "New with Defects",
    "Pre-owned - Excellent",
    "Pre-owned - Good",
    "Pre-owned - Fair",
    "Pre-owned - Damaged"
  ]
};

export const WHATNOT_CONDITIONS: readonly string[] = [...new Set(Object.values(WHATNOT_CONDITIONS_BY_CATEGORY).flat())];

export function whatnotConditions(category: string, subCategory: string): readonly string[] {
  for (const key of [subCategory, category]) {
    if (Object.prototype.hasOwnProperty.call(WHATNOT_CONDITIONS_BY_CATEGORY, key)) {
      return WHATNOT_CONDITIONS_BY_CATEGORY[key]!;
    }
  }
  return WHATNOT_CONDITIONS;
}

export function isWhatnotCondition(category: string, subCategory: string, condition: string): boolean {
  return whatnotConditions(category, subCategory).includes(condition);
}

/** Clear an incompatible condition when either category selection changes. */
export function retainWhatnotCondition(category: string, subCategory: string, condition: string): string {
  return isWhatnotCondition(category, subCategory, condition) ? condition : "";
}


export interface InventoryCategory {
  id: string;
  name: string;
  parentId: string | null;
  children?: InventoryCategory[];
}

export function flattenInventoryCategories(rows: readonly InventoryCategory[]): InventoryCategory[] {
  return rows.flatMap((row) => [row, ...flattenInventoryCategories(row.children ?? [])]);
}

/** A selected child supplies both CSV columns; custom/parent-only selections fail export validation. */
export function inventoryCategoryPair(rows: readonly InventoryCategory[], id: string | null | undefined): { category: string; subCategory: string } {
  const flat = flattenInventoryCategories(rows);
  const selected = flat.find((row) => row.id === id);
  const parent = flat.find((row) => row.id === selected?.parentId);
  return { category: parent?.name ?? selected?.name ?? "", subCategory: parent ? selected?.name ?? "" : "" };
}

export function defaultInventoryCategoryId(rows: readonly InventoryCategory[]): string | null {
  const flat = flattenInventoryCategories(rows);
  const parent = flat.find((row) => row.name === "Toys & Hobbies" && row.parentId === null);
  if (!parent) return null;
  return flat.find((row) => row.name === "Funko Pop!" && row.parentId === parent.id)?.id ?? null;
}

/** Convert only the old five inventory labels, preserving exact marketplace labels. */
export function normalizeInventoryCondition(value: string): string {
  const legacy: Record<string, string> = { mint: "Mint", "near-mint": "Near Mint", good: "Good", fair: "Fair", poor: "Poor" };
  return legacy[value] ?? value;
}
